import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

@inject('store')
@observer
class Auth extends Component {
    render() {
        const { ES: data = [], isCloseMonth, isSave, user, isAdmin } = this.props.store.auth;
        if (user.email === 'admin') return this.props.children;
        if (isAdmin) return null;
        const noAuth = ['edit_week', 'edit_daily'];
        // 未付费、表格关闭
        if (!isSave) return null;
        // 超出表格关闭日期表格关闭保存按钮
        if (isCloseMonth && !noAuth.includes(this.props.auth)) {
            return null
        }
        if (data.includes(this.props.auth)) {
            return this.props.children
        } else {
            return null
        }
    }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/components/table/Auth.js